
export { default as startDatadogRum } from "./datadog/datadog"